import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import { styled } from '@mui/system';

const SnackbarMessage = styled('div')(({ type }) => ({
    backgroundColor:
        type === 'success' ? '#4caf50' :
            type === 'error' ? '#f44336' : '#333',
    color: '#fff',
    padding: '8px 16px',
    borderRadius: '20px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1rem',
    // fontSize: '0.875rem',
    textAlign: 'center',
    maxWidth: '90vw',
    minWidth: '250px',
}));

const Toaster = ({
    open,
    message,
    type = '',
    autoHideDuration = 5000,
    onClose = () => { },
}) => {
    return (
        <Snackbar
            open={open}
            autoHideDuration={autoHideDuration}
            onClose={onClose}
            onClick={onClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} // still included for clarity
            message={<SnackbarMessage type={type}>{message}</SnackbarMessage>}
            sx={{
                // Always center manually
                position: 'fixed',
                bottom: 20,
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 1400, // ensure above other content
                width: 'auto',
                maxWidth: '90vw',
                '& .MuiSnackbarContent-root': {
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                    border: 'none',
                    padding: 0,
                    display: 'flex',
                    justifyContent: 'center',
                },
            }}
        />
    );
};

export default Toaster;
